import { ProfileRedirect } from "@/components/ProfileRedirect";

const ShaanProfile = () => {
  return <ProfileRedirect username="shaan-ray-1" />;
};

export default ShaanProfile;
